import format from 'date-fns/format';
import Menu from '@mui/material/Menu';
import { useSelector } from 'react-redux';
import { Fragment, useState } from 'react';
import Print from '@mui/icons-material/Print';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import ListAlt from '@mui/icons-material/ListAlt';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ganttStore from '../../ganttConfig/ganttStore';
import { drawFloatLayer } from '../../ganttConfig/float';
import GanttIcon from '@blackhyve/common/src/icons/GanttIcon';
import { addDays, isAfter, isBefore, subDays } from 'date-fns';
import { addWeekdaysLayer } from 'features/gantt/layers/addWeekdaysLayer';
import { drawCompanyColorLayer } from 'features/tasksGantt/utils/gantt/taskGanttLayers';
import { addForecastedDatesLayer } from 'features/gantt/layers/addForecastedDatesLayer';
import { addBaselineLayer } from '../../ganttConfig/baseline';

const exportPdfStyle = `.company-avatar{
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #bdbdbd;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fafafa !important;
          font-size: 9px;
          display: inline-flex;
          position: relative;
          vertical-align: middle;
          text-transform: uppercase;
        }
        .company-grid-icon{
          aspect-ratio: 1;
          height: max(60%, 1em);
          width: auto;
          border-radius: 50%;
          position: relative;
          vertical-align: middle;
          font-size: 0.7rem;
        }
        .gantt_grid_head_cell{
          color: black !important;
        }
        .gantt_tree_content{
          color: black;
        }
        .gantt_task_line{
          background-color: #448aff;
        }

        .gantt_task_progress{
          background-color: rgba(0,0,0,.15);
        }

        .gantt_task_line.gantt_project.gantt_bar_project{
          background-color: #ccc;
          opacity: 0.6;
          border: 0px;
          border-radius: 0px;
        }

        .green{
          background-color: rgb(30, 185, 128) !important;
          opacity: 0.6;
        }

        .orange{
          background-color: rgb(254, 192, 105) !important;
          opacity: 0.8;
        }

        .targetEndDate{
          position: absolute;
          border-radius: 2px;
          border: 0px;
        }

        .export-info{
          font-family: sans-serif;
          padding: 10px;
          padding-top: 20px;
          font-size: 12px;
        }

        .project-title{
          padding-left: 10px;
          font-family: sans-serif;
        }

        .company-avatar{
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #bdbdbd;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fafafa !important;
          font-size: 9px;
          display: inline-flex;
          position: relative;
          vertical-align: middle;
          text-transform: uppercase;
        }

        .company-grid-icon{
          aspect-ratio: 1;
          height: max(60%, 1em);
          width: auto;
          border-radius: 50%;
          position: relative;
          vertical-align: middle;
          font-size: 0.7rem;
        }
        .gantt_grid_head_cell{
          color: black !important;
        }

        .gantt_tree_content{
          color: black;
        }
        
        .baseline {
          position: absolute;
          margin-top: -7px;
          height: 5px;
          z-index: 4;
          border-radius: 1px;
          background: rgba(0, 0, 0, 0.40);
        }
        `;

const exportLayout = {
  rows: [
    {
      cols: [
        {
          width: 1200,
          rows: [
            { view: 'grid', scrollX: 'gridScroll', scrollable: true, scrollY: 'scrollVer' },
            { view: 'scrollbar', id: 'gridScroll', group: 'horizontal' },
          ],
        },
      ],
    },
    { view: 'scrollbar', id: 'scrollHor', group: 'horizontal' },
  ],
};

/**
 * Print Menu
 * @param {String} ganttId
 * @param {String} printTitle
 * @returns
 */
const PrintMenu = ({ ganttId, printTitle }) => {
  const gantt = ganttStore.getGantt(ganttId);
  const [anchorEl, setAnchorEl] = useState(null);
  const todayDate = format(new Date(), 'yyyy-MM-dd');
  const time = format(new Date(), 'hh:mm a');

  const timeFrameFilters = useSelector(
    (state) => state.customViews?.menus?.filters?.currentValue
  )?.filter((filterObj) => filterObj.type === 'timeFrameFilter');


  const updateColumnWidth = (columns) => {
    let actionOnRender = {};
    columns.forEach(function (column, index) {
      if (column.name === 'action') {
        actionOnRender = column.onrender;
        column.onrender = () => { };
        column.label = 'No';
      }

      if (column.name !== 'text') {
        return;
      }
      const nodes = document.querySelectorAll(`.gantt_cell[data-column-index="${index}"]`);
      let maxWidth = 0;
      nodes.forEach(function (node) {
        if (maxWidth < node.scrollWidth) {
          maxWidth = node.scrollWidth;
        }
      });
      gantt.config.grid_width += maxWidth;
      column.previous_width = column.width;
      column.width = maxWidth + 12;
    });
    gantt.resetLayout();
    return actionOnRender;
  };

  const resetColumnWidth = (columns, actionOnRender) => {
    columns.forEach(function (column) {
      if (column.name === 'action') {
        column.onrender = actionOnRender;
        column.label = '';
      }

      if (column.name !== 'text') {
        return;
      }

      column.width = column.previous_width;
      delete column.previous_width;
    });
  };

  const initializeCustomLayers = () => {
    addWeekdaysLayer(ganttId);
    drawFloatLayer(ganttId);
    drawCompanyColorLayer(ganttId);
    addForecastedDatesLayer(ganttId);
    addBaselineLayer(ganttId);
  };

  const handlePrintListView = () => {
    setAnchorEl(null);
    const previousLayout = gantt.config.layout;
    gantt.config.layout = exportLayout;
    const actionOnRender = updateColumnWidth(gantt.config.columns);

    gantt.exportToPDF({
      name: `${printTitle}-${todayDate}.pdf`,
      raw: true,
      header: `<style>${exportPdfStyle}</style><h3 class="project-title">${printTitle}</h3>`,
      footer: `<div class="export-info">Exported on ${todayDate} at ${time}</div>`,
    });

    resetColumnWidth(gantt.config.columns, actionOnRender);
    gantt.config.layout = previousLayout;
    gantt.resetLayout();

    initializeCustomLayers();
  };

  const handlePrintGanttPdf = () => {
    setAnchorEl(null);
    const actionOnRender = updateColumnWidth(gantt.config.columns);
    initializeCustomLayers();

    const defaultStartDate = gantt.constants?.start_date
      ? new Date(gantt.constants?.start_date.getTime())
      : null;
    const defaultEndDate = gantt.constants?.end_date
      ? new Date(gantt.constants?.end_date?.getTime())
      : null;

    let startDate = null;
    let endDate = null;

    timeFrameFilters?.forEach((timeFrame) => {
      const { newStartDate, newEndDate } = getTimeFrameFilterDates(
        timeFrame.value.value,
        defaultStartDate,
        defaultEndDate
      );
      if (startDate === null || isBefore(newStartDate, startDate)) {
        startDate = newStartDate;
      }
      if (endDate === null || isAfter(newEndDate, endDate)) {
        endDate = newEndDate;
      }
    });

    if (startDate) {
      gantt.config.start_date = subDays(startDate, 1);
    }
    if (endDate) {
      gantt.config.end_date = addDays(endDate, 1);
    }

    gantt.config.autosize = 'x';
    gantt.exportToPDF({
      name: `${printTitle}-${todayDate}.pdf`,
      header: `<style>${exportPdfStyle}</style><h3 class="project-title">${printTitle}</h3>`,
      footer: `<div class="export-info">Exported on ${todayDate} at ${time}</div>`,
      raw: true,
    });

    if (gantt.constants?.start_date && gantt.constants?.end_date) {
      gantt.config.start_date = gantt.constants?.start_date;
      gantt.config.end_date = gantt.constants?.end_date;
    } else {
      gantt.config.start_date = null;
      gantt.config.end_date = null;
      gantt.config.fit_tasks = true;
    }

    gantt.config.autosize = false;
    gantt.$container.parentNode.style.width = '100%';
    gantt.render();

    resetColumnWidth(gantt.config.columns, actionOnRender);
    gantt.resetLayout();
    initializeCustomLayers();
    gantt.render();
  };

  return (
    <Fragment>
      <IconButton size={'small'} onClick={(event) => setAnchorEl(event.currentTarget)}>
        <Print />
      </IconButton>
      {anchorEl !== null ? (
        <Menu
          anchorEl={anchorEl}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          getContentAnchorEl={null}
          open={Boolean(anchorEl)}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={() => setAnchorEl(null)}
        >
          <MenuItem onClick={handlePrintListView}>
            <ListItemIcon>
              <ListAlt fontSize={'small'} />
            </ListItemIcon>

            <ListItemText primary={'List View'} />
          </MenuItem>
          <MenuItem onClick={handlePrintGanttPdf}>
            <ListItemIcon>
              <GanttIcon fontSize={'small'} />
            </ListItemIcon>
            <ListItemText primary={'Gantt View'} />
          </MenuItem>
        </Menu>
      ) : null}
    </Fragment>
  );
};

const getTimeFrameFilterDates = (timeFrameId, defaultStartDate, defaultEndDate) => {
  const currentDate = new Date();
  const adjustments = {
    2: { start: -7 }, // Past 7 Days & All Future
    3: { start: -7, end: 7 }, // Past 7 Days and Next 7 Days
    4: { start: -14, end: 14 }, // Past 14 Days and Next 14 Days
    5: { start: 0 }, // Today
    6: { start: 0 }, // Today Onward
    7: { start: -7, end: 28 }, // 4 Week lookahead
    8: { start: -7, end: 42 }, // 6 Week lookahead
  };

  const adjust = adjustments[timeFrameId] || {};
  const newStartDate = adjust.start ? addDays(currentDate, adjust.start) : defaultStartDate;
  const newEndDate = adjust.end ? addDays(currentDate, adjust.end) : defaultEndDate;

  return { newStartDate, newEndDate };
};

export default PrintMenu;
